<template>
  <div class="jumbotron">
    <h1>Login</h1>
    <div v-if="error" class="alert alert-danger">
      {{ error }}
    </div>
    <div v-if="isAPIScience" class="alert alert-warning">
      <b>API Science Customers: </b> with the move from API Science to APImetrics, you will need a
      new login. Please <router-link :to="{ name: 'register' }"> register </router-link> if you have
      not already. We have migrated the monitors from API Science, if you have lost access to them,
      please contact us using the chat functionality in the bottom right hand corner.
    </div>
    <p>
      Login to use the API monitoring service that is the choice of the UK's top banks and some of
      the world's most secure API providers.
    </p>

    <ul>
      <li>
        Get at-a-glance indications of API service health before it affects users and regulators
      </li>
      <li>See how your competitors stack up</li>
      <li>Verify all your API data</li>
      <li>Look beyond pass-rates and see API availability from where your users are</li>
      <li>
        Built-in reporting, AI driven analysis, and bank grade security, not to mention instant SLA
        reporting
      </li>
    </ul>
    <p>
      <LoadingAnim v-if="loading" />
      <button v-else class="btn btn-primary btn-lg" type="button" @click.prevent="loginClicked">
        Login
      </button>
    </p>

    <p>
      Don't have an APImetrics account yet?
      <router-link :to="{ name: 'register' }"> Sign up in just two clicks. </router-link>
    </p>

    <p>Problems logging in? <a href="http://apimetrics.io/contact/">Contact Us</a> for help.</p>
  </div>
</template>

<script>
import { get } from 'vuex-pathify';

const DEFAULT_PROJECT_ID = 'defaultProjectId';
const DEFAULT_HOME = 'welcome-home';
// const APIM_TOKEN_KEY = 'apimAccessToken';

export default {
  name: 'LoginView',
  beforeRouteEnter(to, { name, path }, next) {
    next((vm) => {
      //  console.log('beforeRouteEnter', name, path);
      // access to component instance via `vm`
      if (to && to.name === 'logout') {
        vm.logout();
      }
      if (!name || name === 'login' || name === 'logout' || name === 'register') {
        // eslint-disable-next-line no-param-reassign
        vm.previousRoute = { name: DEFAULT_HOME };
      } else {
        // eslint-disable-next-line no-param-reassign
        vm.previousRoute = { path };
      }
    });
  },
  data() {
    return {
      error: '',
      previousRoute: { name: DEFAULT_HOME },
    };
  },
  computed: {
    loaded: get('account2/loaded'),
    loading() {
      return this.$auth.isAuthenticated && this.$auth.user && !this.loaded;
    },
    isAPIScience() {
      return this.$route.query.apiscience;
    },
  },
  watch: {
    loaded: 'doCheck',
    '$auth.isAuthenticated': 'doCheck',
  },
  mounted() {
    this.doCheck();
  },
  methods: {
    goToRoute(route) {
      const resolved = this.$router.resolve(route);
      if (route.path && resolved.route && !resolved.route.name) {
        window.location.href = route.path;
      } else {
        this.$router.replace(route);
      }
    },
    login() {
      this.$auth.loginWithRedirect({ authorizationParams: { screen_hint: 'login' } });
    },
    loginClicked() {
      this.$auth.loginWithRedirect({
        authorizationParams: { screen_hint: 'login', prompt: 'login' },
      });
    },
    loginForRoute(route) {
      if (!this.$route.query.error) {
        this.$cookies.set('continue-url', route, '1h');
        this.login();
      } else {
        this.error = this.$route.query.error_description;
        this.$route.query.error = '';
      }
    },
    doCheck() {
      if (!this.$auth.isAuthenticated || !this.$auth.user) {
        if (this.$route.query['continue-url']) {
          try {
            // Enforces the continue-url is only ever relative
            const url = new URL(this.$route.query['continue-url']);
            const path = url.toString().substring(url.origin.length);
            this.previousRoute = { path };
          } catch (error) {
            console.log(error);
          }
        }
        this.$nextTick(() => this.loginForRoute(this.previousRoute));
      } else if (this.loaded) {
        if (this.$cookies.isKey('continue-url')) {
          const nextRoute = this.$cookies.get('continue-url');
          this.$cookies.remove('continue-url');
          if (nextRoute && this.$router.currentRoute.path !== nextRoute.path) {
            this.$nextTick(() => this.goToRoute(nextRoute));
          }
        } else {
          this.$nextTick(() => this.goToRoute(this.previousRoute));
        }
      }
    },
    async logout() {
      // window.sessionStorage.removeItem(APIM_TOKEN_KEY);
      window.sessionStorage.removeItem(DEFAULT_PROJECT_ID);
      await this.$fetcher.logout().catch((ex) => {
        console.warn(ex);
      });
      await this.$auth.logout({ returnTo: process.env.VUE_APP_AUTH0_REDIRECT_URI });
    },
  },
};
</script>
